import type { ReactNode } from 'react'

export interface PageTransitionProps {
  children: ReactNode
  /** Chave para forçar re-animação ao mudar (ex.: pathname) */
  transitionKey?: string
  /** Classe adicional no wrapper */
  className?: string
}

/**
 * Wrapper que aplica a animação de transição padrão ao abrir uma tela.
 * Usado no AppShell para todas as páginas internas.
 *
 * Animação: slide da direita + fade (mobile: mais pronunciado).
 * Duração: ~220–240ms. Respeita prefers-reduced-motion.
 *
 * @see docs/PADRAO_TELAS_CADASTROS.md
 * @see docs/TRANSICOES_TELAS.md
 */
export const PageTransition = ({
  children,
  transitionKey,
  className = '',
}: PageTransitionProps) => (
  <div
    key={transitionKey}
    className={`synap-page-transition ${className}`.trim()}
  >
    {children}
  </div>
)
